import PropTypes from 'prop-types'
import Slider from 'react-slick'
import styled from 'styled-components'
import noop from 'lodash/noop'
import { getImageUrl } from '@/utils/image'
import { breakpoints, colors, fontWeights } from '@/styles'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const SliderViewButton = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  height: 35px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.white};
  border-radius: 2px;
  box-shadow: 1px 2px 4px 0 rgba(0, 0, 0, 0.5);
  font-size: 14px;
  color: ${colors.regular};
  font-weight: ${fontWeights.regular};
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;

  @media (max-width: ${breakpoints.phoneMax}) {
    display: none;
  }
`

const SliderWrapper = styled.div`
  position: relative;
  background-color: #eee;
`

const PhotoWrapper = styled.div`
  position: relative;
`

const ImageWrap = styled.span`
  box-sizing: border-box;
  display: block;
  overflow: hidden;
  width: initial;
  height: initial;
  background: none;
  opacity: 1;
  border: 0px;
  margin: 0px;
  padding: 0px;
  position: absolute;
  inset: 0px;
`

const ListingImage = styled.img`
  position: absolute;
  inset: 0px;
  box-sizing: border-box;
  padding: 0px;
  border: none;
  margin: auto;
  display: block;
  width: 0px;
  height: 0px;
  min-width: 100%;
  max-width: 100%;
  min-height: 100%;
  max-height: 100%;
  object-fit: cover;
  object-position: center center;
`

const PhotoSlider = ({
  images,
  buttonText = '',
  altText = '',
  onMouseDown,
  openImage = noop,
  placeholder = 'blur',
  sizes = '100vw',
  ...rest
}) => {
  return (
    <Slider {...rest}>
      {images.map((image, index) => (
        <SliderWrapper key={index}>
          {!!buttonText && (
            <SliderViewButton className="photo-carousel-view-button">{buttonText}</SliderViewButton>
          )}
          <PhotoWrapper className="photo-carousel-image" onClick={() => openImage(index)}>
            <ImageWrap>
              <ListingImage
                src={getImageUrl(image, {
                  fit: 'fit-in/1150x785',
                  quality: 100
                })}
                alt={`${altText} ${index + 1}`}
              />
            </ImageWrap>
          </PhotoWrapper>
        </SliderWrapper>
      ))}
    </Slider>
  )
}

PhotoSlider.propTypes = {
  images: PropTypes.array.isRequired,
  buttonText: PropTypes.string,
  altText: PropTypes.string,
  onMouseDown: PropTypes.func,
  openImage: PropTypes.func
}

export default PhotoSlider
